import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { AppErrorMessage } from '../common/AppErrorMessage';
import { FullPageSpinner } from '../common/FullPageSpinner';
import { canReloadForStaleChunk, reloadForStaleChunk } from '../../utils/staleChunk';

export const RouteError = () => {
  const error = useRouteError();
  const reloading = canReloadForStaleChunk(error);

  useEffect(() => {
    if (reloading) {
      reloadForStaleChunk();
    }
  }, [reloading]);

  return (
    <div data-build="stale-chunk-test">{reloading ? <FullPageSpinner /> : <AppErrorMessage />}</div>
  );
};
